import { useAccountRepository } from '@frontend/repository';
import { CreateRequirement } from '@frontend/stock/types';

export const FORM_ID = 'create-requirement-modal-form';

export interface CreateRequirementModalProps {
    formId?: string;
}

export interface CreateRequirementWithSpot extends CreateRequirement {
    spot_id?: string;
}

interface ViewProps {
    currentAccount: string;
    getRequiredFields: () => (keyof CreateRequirementWithSpot)[];
    checkSubmitDisabled: (formValues: { [key: string]: any }) => boolean;
}

export const useCreateRequirementModal = (props: CreateRequirementModalProps): ViewProps => {
    const { store } = useAccountRepository();

    const getRequiredFields = (): (keyof CreateRequirementWithSpot)[] => {
        return ['spot_id', 'product_id', 'min', 'max'];
    };

    const checkSubmitDisabled = (formValues: { [key: string]: any }): boolean => {
        if (!formValues.spot_id || !formValues.product_id || !formValues.min || !formValues.max) {
            return true;
        }
        if (formValues.min && formValues.max && Number(formValues.min) > Number(formValues.max)) {
            return true;
        }
        return false;
    };

    return {
        currentAccount: store.currentAccount!,
        getRequiredFields,
        checkSubmitDisabled
    };
};
